import React, { useState, Fragment } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import * as styles from './styles.module.css';

export default function ExternalLink({
  classNameLink,
  classNameOverlay,
  externalURL,
  messageBody,
  messageTitle,
  buttonOkTitle,
  buttonCancelTitle,
  children,
  onOpenHandler,
  onOkHandler,
  onCancelHandler,
  isMenuOpen,
  ...props
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const returnObj = { children: children, url: externalURL };

  const handleOpenModalClick = () => {
    setIsModalOpen(true);
    onOpenHandler && onOpenHandler(returnObj);
  };

  const handleOKClick = () => {
    onOkHandler && onOkHandler(returnObj);
    typeof window !== 'undefined' && window.open(externalURL);
    setIsModalOpen(false);
  };

  const handleCancelClick = () => {
    onCancelHandler && onCancelHandler(returnObj);
    setIsModalOpen(false);
  };

  return (
    <Fragment>
      <button {...props} className={`${styles.button} ${classNameLink}`} onClick={handleOpenModalClick}>
        {children}
      </button>
      {isModalOpen &&
        createPortal(
          <div
            className={`${styles.overlayBackground} ${classNameOverlay} ${styles.overlay}`}
            style={{ zIndex: isMenuOpen ? 10000 : 9999 }}
          >
            <div className={`${styles.modal} modal-container`}>
              <div className='close'>
                <button className="btn-close" onClick={handleCancelClick}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
                    <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" fill="#212D5E"></rect>
                    <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" fill="#212D5E"></rect>
                    <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" fill="#212D5E"></rect>
                    <rect width="29.64" height="2.90182" rx="1.45091" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 2.05469 23.0103)" stroke="#212D5E"></rect>
                    <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" fill="#212D5E"></rect>
                    <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" fill="#212D5E"></rect>
                    <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" fill="#212D5E"></rect>
                    <rect x="2.05469" width="29.64" height="2.90182" rx="1.45091" transform="rotate(45 2.05469 0)" stroke="#212D5E"></rect>
                  </svg>
                </button>
              </div>
              {messageTitle && (
                <div className='modal-title'>
                  <div dangerouslySetInnerHTML={{ __html: messageTitle }} />
                </div>
              )}
              <div className='modal-body'>
                <div dangerouslySetInnerHTML={{ __html: messageBody }} />
              </div>
              <div className='modal-actions'>
                <button onClick={handleOKClick}>
                  {buttonOkTitle || 'Continue to External Site'}
                </button>
                <button onClick={handleCancelClick}>
                  {buttonCancelTitle || 'Remain on NalmefeneHCl.com'}
                </button>
              </div>
            </div>
          </div>,
          document.body
        )
      }
    </Fragment>
  );
}

ExternalLink.propTypes = {
  externalURL: PropTypes.string.isRequired,
  messageBody: PropTypes.string.isRequired,
  messageTitle: PropTypes.string,
  buttonOkTitle: PropTypes.string,
  buttonCancelTitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  onOpenHandler: PropTypes.func,
  onOkHandler: PropTypes.func,
  onCancelHandler: PropTypes.func,
  classNameLink: PropTypes.string,
  classNameOverlay: PropTypes.string,
  isMenuOpen: PropTypes.bool,
};